import { render, staticRenderFns } from "./modalPasswordExpiredFields.vue?vue&type=template&id=b5738746&scoped=true"
import script from "./modalPasswordExpiredFields.vue?vue&type=script&lang=js"
export * from "./modalPasswordExpiredFields.vue?vue&type=script&lang=js"
import style0 from "./modalPasswordExpiredFields.vue?vue&type=style&index=0&id=b5738746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5738746",
  null
  
)

export default component.exports